import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";

export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

export const fetchRaceAiAnalysis = createAsyncThunk(
  "/raceAiAnalysis/fetch",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${getBaseUrl()}/race/${id}/ai-analysis/public`);
      return res.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return rejectWithValue("No AI analysis available for this race yet.");
      }
      return rejectWithValue(
        error?.response?.data?.message || "Unable to load AI analysis right now."
      );
    }
  }
);

const getRaceAiAnalysisSlice = createSlice({
  name: "raceAiAnalysis",
  initialState: {
    data: null,
    status: STATUSES.IDLE,
    errorMessage: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRaceAiAnalysis.pending, (state) => {
        state.status = STATUSES.LOADING;
        state.errorMessage = null;
      })
      .addCase(fetchRaceAiAnalysis.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
        state.errorMessage = null;
      })
      .addCase(fetchRaceAiAnalysis.rejected, (state, action) => {
        state.data = null;
        state.status = STATUSES.ERROR;
        state.errorMessage =
          action.payload || "Unable to load AI analysis right now.";
      });
  },
});

export default getRaceAiAnalysisSlice.reducer;
